import React, { useCallback } from 'react';
import { Switch } from 'framework/Switch';

import { GridHeader } from './GridHeader';
import { GridHeaderSwitchProps } from './types';

export const GridSwitchHeader: React.FC<GridHeaderSwitchProps> = ({ column, index, style }) => {
  const { label, checked, onClick } = column.props;

  const onMouseDown = useCallback(() => onClick(!checked), [checked, onClick]);

  return (
    <GridHeader onMouseDown={onMouseDown} column={column} index={index} style={style}>
      <Switch checked={checked} width="fit-content" right_label={label} />
    </GridHeader>
  );
};
